import { Text } from '@components/ui-core/text/text'

import style from './bottom-text.module.scss'
export const BottomText = ({ children }: { children: React.ReactNode }) => {
  return (
    <Text as="span" className={style.bottomText}>
      {children}
    </Text>
  )
}
